/**
 * HeadsetIcon/index.js
 * desc: headset icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const HeadsetIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="headset icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.headset.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg"><path d="M9 0a9 9 0 00-9 9v7c0 1.66 1.34 3 3 3h3v-8H2V9c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1H9v2h6c1.66 0 3-1.34 3-3V9a9 9 0 00-9-9z" /></svg>
    </IconButton>
);


export default HeadsetIcon;
